import { useEffect, useState } from "react";
import ImageModal from "./Outerinnerpage/KYC/ImageModal";
import { Link } from "react-router-dom";
import axios from "axios";
import ReactPaginate from "react-paginate";
import img from "../scenes/global/Images/user.jpg"

import {
  BsFillHandThumbsUpFill,
  BsFillHandThumbsDownFill,
  BsFillEyeFill,
} from "react-icons/bs";
import { AiFillHome } from "react-icons/ai";
import { BiMessageAltDetail } from "react-icons/bi";
import { FaPeopleGroup, FaIndianRupeeSign } from "react-icons/fa6";

const AdminDashboard = () => {

  const [depositApi, setDepositApi] = useState([]);
  const [count, setCount] = useState(0);
  const [count2, setCount2] = useState(0);
  // const [todayActiveCount, setTodayActiveCount] = useState(0);
  const PER_PAGE = 10;
  const [currentPage, setCurrentPage] = useState(0);
  function handlePageClick({ selected: selectedPage }) {
    setCurrentPage(selectedPage);
  }
  const offset = currentPage * PER_PAGE;
  const pageCount = Math.ceil(depositApi.length / PER_PAGE);

  const baseUrl = `https://apimlm.bloomitsolutions.in`

  const incrementCount = () => {
    setCount(count + 1);
  };
  const incrementCount2 = () => {
    setCount2(count2 + 1);
  };

  const getDashboard = async () => {
    try {
      const response = await axios.get("https://apimlm.bloomitsolutions.in/ecomroutes/getProducts");
      const empData = response.data;
      setDepositApi(empData);
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  const [userProfile, setUserProfile] = useState([]);
  // const activeStatusCount = userProfile.filter(data => data.status === 'active');

  const getUserProfile = async () => {
    try {
      const response = await axios.get(
        "https://apimlm.bloomitsolutions.in/userroutes/users"
      );
      setUserProfile(response.data);
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };
  

  const [userRequest, setUserRequest] = useState([]);

  const getUserRequest = async () => {
    try {
      const response = await axios.get(
        "https://apimlm.bloomitsolutions.in/pingeneration//pin-request/all"
      );
      setUserRequest(response.data);
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  const [userIncome, setUserIncome] = useState([]);

  const getUserIncome = async () => {
    try {
      const response = await axios.get(
        "https://apimlm.bloomitsolutions.in/auth/getAllAdminIncomes"
      );
      setUserIncome(response.data);
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  const [activationRecords, setUserreg] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`https://apimlm.bloomitsolutions.in/userroutes/users`);
        setUserreg(response.data);
      } catch (error) {
        console.error("Error fetching data: ", error);
      }
    };

    fetchData();
  }, []);

  // Filter active users and get the latest 5 records
  const activeUsers = activationRecords
    .filter(user => user.status === "Active")
    

    // const [userreg, setUserreg] = useState([]);
  const [usersRegisteredToday, setUsersRegisteredToday] = useState(0);

  useEffect(() => {
    const fetchUserRegistrationData = async () => {
      try {
        const response = await axios.get('https://apimlm.bloomitsolutions.in/userroutes/users');
        setUserreg(response.data);

        // Get the current date in the format of 'createdAt' (assuming 'createdAt' is in ISO format)
        const currentDate = new Date().toISOString().split('T')[0];

        // Filter users who were registered today
        const usersToday = response.data.filter((user) => {
          return user.createdAt.split('T')[0] === currentDate;
        });

        setUsersRegisteredToday(usersToday.length);
      } catch (error) {
        console.error('Error fetching data: ', error);
      }
    };

    fetchUserRegistrationData();
  }, []);

  const [todaysActiveCount, setTodaysActiveCount] = useState(0);

  useEffect(() => {
    const fetchUserActiveData = async () => {
      try {
        const response = await axios.get('https://apimlm.bloomitsolutions.in/userroutes/users');
        setUserreg(response.data);

        // Get the current date in the format of 'createdAt' (assuming 'createdAt' is in ISO format)
        const currentDate = new Date().toISOString().split('T')[0];

        // Filter active users who joined today
        const activeUsersToday = response.data.filter((user) => {
          return user.status === 'Active' && user.updatedAt.split('T')[0] === currentDate;
        });

        setTodaysActiveCount(activeUsersToday.length);
      } catch (error) {
        console.error('Error fetching data: ', error);
      }
    };

    fetchUserActiveData();
  }, []);



  const [userMessage, setUserMessage] = useState([]);

  const getUserMessage = async () => {
    try {
      const response = await axios.get(
        "https://apimlm.bloomitsolutions.in/contentroutes/getAllpackages"
      );
      setUserMessage(response.data);
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  const [pendingRequest, setpendingRequest] = useState([]);

  useEffect(() => {
    const fetchRequest = async () => {
      try {
        const response = await axios.get(`https://apimlm.bloomitsolutions.in/pingeneration//pin-request/all`);
        setpendingRequest(response.data);
      } catch (error) {
        console.error("Error fetching data: ", error);
      }
    };

    fetchRequest();
  }, []);

  // Filter active users and get the latest 5 records
  const Pending = pendingRequest
    .filter(user => user.status === "Pending")


  const [showImageModal, setShowImageModal] = useState(false);
  const [enlargedImageUrl, setEnlargedImageUrl] = useState("");


  const openImageModal = (imageUrl) => {
    setEnlargedImageUrl(imageUrl);
    setShowImageModal(true);
  };

  const closeImageModal = () => {
    setEnlargedImageUrl("");
    setShowImageModal(false);
  };

  const [userProducts, setUserProducts] = useState([]);

  const getUserProducts = async () => {
    try {
      const response = await axios.get(
        "https://apimlm.bloomitsolutions.in/ecomroutes/getProducts"
      );
      setUserProducts(response.data);
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };


  const [userComplaint, setUserComplaint] = useState([]);

  const getUserComplaint = async () => {
    try {
      const response = await axios.get(
        "https://apimlm.bloomitsolutions.in/auth/getComplaints"
      );
      setUserComplaint(response.data);
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  useEffect(() => {
    getDashboard();
    getUserProfile();
    getUserRequest();
    getUserComplaint();
    getUserProducts();
    getUserMessage();
    getUserIncome();
  }, []);



  return (
    <section>
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12">
            <div className="row mt-3">
              <div className="col-lg-10 mt-5">
                <div className="row">
                  <div className="col-lg-1">
                    <Link to="/home">
                      <h6>
                        {/* <AiFillHome /> */}
                        Home
                      </h6>
                    </Link>
                  </div>
                  /
                  <div className="col-lg-1">
                    <h6>Dashboard</h6>
                  </div>
                </div>
              </div>

              {/* =====================row ================================= */}

              <div className="row mt-4">
                <div className="col-lg-3 mt-3">
                  <div className="card border-0  rounded-3 shadow text-dark bgimage">
                    <div className="card-header ">
                      <h5><b>Total Joining</b></h5>
                      <h2>
                        <b><BsFillEyeFill />{userProfile.length}
                        </b>

                      </h2>
                    </div>
                    <div className="card-body ">
                      <canvas
                        id="widege1"
                        class="chart-dropshadow chartjs-render-monitor"
                        style={{
                          display: "block",
                          height: "138px",
                          width: "240px",
                        }}

                      ></canvas>
                    </div>
                  </div>
                </div>

                <div className="col-lg-3 mt-3">
                  <div className="card border-0 border-white rounded-3 shadow  text-dark bgimage2">
                    <div className="card-header">
                      <h5><b>Total Income</b></h5>
                      <h2>
                        <b><FaIndianRupeeSign />
                          {userIncome.totalAdminCharges}</b>

                      </h2>
                    </div>
                    <div className="card-body">
                      <canvas
                        id="widege1"
                        class="chart-dropshadow chartjs-render-monitor"
                        style={{
                          display: "block",
                          height: "138px",
                          width: "240px",
                        }}

                      ></canvas>
                    </div>
                  </div>
                </div>

                <div className="col-lg-3 mt-3">
                  <div className="card border-0 border-white rounded-3 shadow text-dark bgimage3">
                    <div className="card-header">
                      <h5><b>Total TDS</b></h5>
                      <h2>
                        <b><FaIndianRupeeSign />
                          {userIncome.totalTDS}</b>

                      </h2>
                    </div>
                    <div className="card-body">
                      <canvas
                        id="widege1"
                        class="chart-dropshadow chartjs-render-monitor"
                        style={{
                          display: "block",
                          height: "138px",
                          width: "240px",
                        }}

                      ></canvas>
                    </div>
                  </div>
                </div>

                <div className="col-lg-3 mt-3">
                  <div className="card border-0 border-white rounded-3 shadow  text-dark bgimage4">
                    <div className="card-header">
                      <h5><b>Total Binary Matching</b></h5>
                      <h2>
                        <b><FaIndianRupeeSign />{userIncome.totalAdminBineryIncome}</b>

                      </h2>
                    </div>
                    <div className="card-body">
                      <canvas
                        id="widege1"
                        class="chart-dropshadow chartjs-render-monitor"
                        style={{
                          display: "block",
                          height: "138px",
                          width: "240px",
                        }}

                      ></canvas>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row mt-4">
                <div className="col-lg-3 mt-3">
                  <div className="card border-0 border-white rounded-3 shadow text-dark bgimage text-center">
                    <div className="card-header">
                      <h6 className="mt-2"><b>Payment Withdraw Request</b></h6>

                      <Link
                        to="/mypayment"
                        className="btn btn-danger btn-sm mt-2"

                      >
                        Click here
                      </Link>


                      <p className="display-6 text-dark mt-2">{count}</p>
                    </div>
                  </div>
                </div>

                <div className="col-lg-3 mt-3">
                  <div className="card border-0 border-white rounded-3 shadow  text-dark bgimage2 text-center">
                    <div className="card-header">
                      <h6 className="mt-2"><b>Joining fund Request</b></h6>
                      <Link
                        to="/myfunddetails"
                        className="btn btn-danger btn-sm mt-2"

                      >
                        Click here
                      </Link>

                      <p className="display-6 text-dark mt-2">{userRequest.length}</p>
                    </div>
                  </div>
                </div>

                <div className="col-lg-3 mt-3">
                  <div className="card border-0 border-white rounded-3 shadow  text-dark bgimage3 text-center">
                    <div className="card-header">
                      <h6 className="mt-2"><b>Pin Request</b></h6>
                      <Link
                        to="/pin-request"
                        className="btn btn-danger btn-sm mt-2"

                      >
                        Click here
                      </Link>

                      <p className="display-6 text-dark mt-2">{Pending.length}</p>
                    </div>
                  </div>
                </div>

                <div className="col-lg-3 mt-3">
                  <div className="card border-0 border-white rounded-3 shadow  text-dark bgimage4 text-center">
                    <div className="card-header">
                      <h6 className="mt-2"><b>Vendor Deposit</b></h6>
                      <Link
                        to="/Vendordeposit"
                        className="btn btn-danger btn-sm mt-2"
                        
                      >
                        Click here
                      </Link>

                      <p className="display-6 text-dark mt-2"></p>
                    </div>
                  </div>
                </div>

                <div className="col-lg-3 "></div>
                <div className="col-lg-3 "></div>
              </div>

              {/* =====================row ================================= */}

              {/* =====================row2 ================================= */}

              <div className="row mt-4">
                <div className="col-lg-3 mt-3">
                  <div className="card border border-0 rounded-3 p-5 text-dark bgimage">
                    <div className="card-header shadow-lg border-0 bgcolor2">
                      <div className="row">
                        <div className="col-lg-12">
                          <h2>
                            <FaPeopleGroup />
                          </h2>
                          <h6><b>Today's Joining</b></h6>
                          <h2><b>{usersRegisteredToday}</b></h2>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-lg-3 mt-3">
                  <div className="card border border-0 rounded-3 p-5 text-dark bgimage2">
                    <div className="card-header shadow-lg border-0 bgcolor2">
                      <div className="row">
                        <div className="col-lg-12">
                          <h2>
                            <FaPeopleGroup />
                          </h2>
                          <h6><b>Today's Active</b></h6>
                          <h2><b>{todaysActiveCount}</b></h2>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-lg-3 mt-3">
                  <div className="card border border-0 rounded-3 p-5 text-dark bgimage3">
                    <div className="card-header shadow-lg border-0 bgcolor2">
                      <div className="row">
                        <div className="col-lg-12">
                          <h2>
                            <FaPeopleGroup />
                          </h2>
                          <h6><b>Vendor Product</b></h6>
                          <h2><b>{depositApi.length}</b></h2>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-lg-3 mt-3">
                  <div className="card border border-0 rounded-3 p-5 text-dark bgimage4">
                    <div className="card-header shadow-lg border-0 bgcolor2">
                      <div className="row">
                        <div className="col-lg-12">
                          <h2>
                            <FaPeopleGroup />
                          </h2>
                          <h6><b>Total Active</b></h6>
                          <h2><b>{activeUsers.length}</b></h2>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* =====================row2 ================================= */}

              {/* =====================row3 ================================= */}

              <div className="row mt-4">


                <div className="col-lg-3 mt-3">
                  <div className="card border border-0 rounded-3 bgimage text-dark">
                    <div className="card-header  border-0">
                      <h5 className=" mt-4"><b>Admin Charges</b></h5>

                      <h3 className=" mt-3">
                        <b><FaIndianRupeeSign /> Rs
                          {userIncome.totalAdminCharges}</b>

                      </h3>

                      <Link
                        to="/adminmain"
                        className="btn btn-danger btn-sm mt-2"
                      >
                        Click here
                      </Link>
                    </div>
                  </div>
                </div>

                <div className="col-lg-3 mt-3">
                  <div className="card border border-0 rounded-3 bgimage2 text-dark">
                    <div className="card-header  border-0">
                      <h5 className=" mt-4"><b>GST</b></h5>

                      <h3 className=" mt-3">
                      <b><FaIndianRupeeSign />
                          {userIncome.totalTDS}</b>
                      </h3>

                      <Link
                        to="/gstmain"
                        className="btn btn-danger btn-sm mt-2"
                      >
                        Click here
                      </Link>
                    </div>
                  </div>
                </div>

                <div className="col-lg-3 mt-3">
                  <div className="card border border-0 rounded-3 bgimage3 text-dark">
                    <div className="card-header  border-0">
                      <h5 className=" mt-4"><b>Total No of Complaints</b></h5>

                      <h3 className=" mt-3"><b>{userComplaint.length}</b></h3>

                      <Link
                        to="/viewcomplaint"
                        className="btn btn-danger btn-sm mt-2"
                      >
                        Click here
                      </Link>
                    </div>
                  </div>
                </div>

                <div className="col-lg-3 mt-3">
                  <div className="card border border-0 rounded-3 bgimage4 text-dark">
                    <div className="card-header  border-0">
                      <h5 className=" mt-4"><b>Vendor Withdraw</b></h5>

                      <h3 className=" mt-3"><b></b></h3>

                      <Link
                        to="/Vendorwithdraw"
                        className="btn btn-danger btn-sm mt-2"
                      >
                        Click here
                      </Link>
                    </div>
                  </div>
                </div>
              </div>

              {/* =====================row3 ================================= */}

              {/* =====================row4 ================================= */}

              <div className="row mt-4">

                <div className="col-lg-3 mt-3">
                  <div className="card border border-0 rounded-3 bgimage text-dark">
                    <div className="card-header  border-0">
                      <h5 className="text-center mt-4"> <b>Saving Wallet</b></h5>

                      <h4 className="text-end"><b><FaIndianRupeeSign/> 3,672</b></h4>
                    </div>
                  </div>
                </div>


                <div className="col-lg-3 mt-3">
                  <div className="card border border-0 rounded-3 bgimage2 text-dark text-center">
                    <div className="card-header border-0">
                      <h5 className="text-center mt-4"><b>Cashback</b></h5>

                      <Link
                        to="/cashback"
                        className="btn btn-danger btn-sm mt-2"
                      >
                        Click here
                      </Link>
                    </div>
                  </div>
                </div>

                {/* <div className="col-lg-3 mt-3">
                  <div className="card border border-0 rounded-3 bgimage3 text-dark text-center">
                    <div className="card-header  border-0">
                      <h5 className="text-center mt-4"><b>Performance Bonus</b></h5>

                      <Link
                        to="/weeklyperformance"
                        className="btn btn-danger btn-sm mt-2"
                      >
                        Click here
                      </Link>
                    </div>
                  </div>
                </div> */}

                <div className="col-lg-3 mt-3">
                  <div className="card border-0 border-white rounded-3 text-dark bgimage3 text-center">
                    <div className="card-header">
                      <h6 className="mt-2"><b>Total Messages</b></h6>
                      {/* <Link
                        to=""
                        className="btn btn-danger btn-sm mt-2"
                        
                      >
                        Click here
                      </Link> */}

                      <p className="display-6 text-dark mt-2"><BiMessageAltDetail/>{userMessage.length}</p>
                    </div>
                  </div>
                </div>

                <div className="col-lg-3 mt-3">
                  <div className="card border border-0 rounded-3 bgimage4 text-dark text-center">
                    <div className="card-header border-0">
                      <h5 className="text-center mt-4"><b>Re-Topup Income</b></h5>

                      <Link
                        to="/retopup"
                        className="btn btn-danger btn-sm mt-2"
                      >
                        Click here
                      </Link>
                    </div>
                  </div>
                </div>
              </div>

              {/* =====================row4 ================================= */}

              {/* =====================row5 ================================= */}

              <div className="row mt-4">
                <div className="col-lg-3 mt-3">
                  <div className="card border border-0 rounded-3 bgimage text-dark text-center">
                    <div className="card-header  border-0">
                      <h5 className="text-center mt-4"><b>Re-Purchase Income</b></h5>

                      <Link
                        to="/repurchase"
                        className="btn btn-danger btn-sm mt-2"
                      >
                        Click here
                      </Link>
                    </div>
                  </div>
                </div>

                <div className="col-lg-3 mt-3">
                  <div className="card border border-0 rounded-3 bgimage2 text-dark text-center">
                    <div className="card-header border-0">
                      <h5 className="text-center mt-4"><b>Vendor Income</b></h5>

                      <Link
                        to="/vendorincome"
                        className="btn btn-danger btn-sm mt-2"
                      >
                        Click here
                      </Link>
                    </div>
                  </div>
                </div>

                <div className="col-lg-3 mt-3">
                  <div className="card border border-0 rounded-3 bgimage3 text-dark text-center">
                    <div className="card-header border-0">
                      <h5 className="text-center mt-4"><b>Activation Products</b></h5>
                      <h2>
                        <b>{userProducts.length}
                        </b>
                      </h2>

                      {/* <Link
                        to="/awardsrewards"
                        className="btn btn-danger btn-sm mt-2"
                      >
                        Click here
                      </Link> */}
                    </div>
                  </div>
                </div>

                <div className="col-lg-3 mt-3">
                  <div className="card border border-0 rounded-3 bgimage4 text-dark text-center">
                    <div className="card-header border-0">
                      <h5 className="text-center mt-4">
                        <b>Distribution Products</b>
                      </h5>

                      <Link
                        to="/distributeproducts"
                        className="btn btn-danger btn-sm mt-2"
                      >
                        Click here
                      </Link>
                    </div>
                  </div>
                </div>
              </div>

              {/* =====================row5 ================================= */}

              {/* =====================row6 ================================= */}

              <div className="row mt-4">
                <div className="col-lg-3 mt-3">
                  <div className="card border border-0 rounded-3 bgimage text-dark text-center">
                    <div className="card-header border-0">
                      <h5 className="text-center mt-4"><b>Vendor Approval</b></h5>

                      <Link
                        to="/savedamount"
                        className="btn btn-danger btn-sm mt-2"
                      >
                        Click here
                      </Link>
                    </div>
                  </div>
                  
                </div>
                <div className="col-lg-3 mt-3">
                  <div className="card border border-0 rounded-3 bgimage2 text-dark text-center">
                    <div className="card-header border-0">
                      <h5 className="text-center mt-4"><b>User Shopping Wallet</b></h5>

                      <Link
                        to="/ShoppingWallet"
                        className="btn btn-danger btn-sm mt-2"
                      >
                        Click here
                      </Link>
                    </div>
                  </div>
                  
                </div>

                {/* <div className="col-lg-3 mt-3">
                  <div className="card border border-0 rounded-3 bgimage3 text-dark text-center">
                    <div className="card-header border-0">
                      <h5 className="text-center mt-4"><b>Total Binary Matching</b></h5>

                      <Link
                        to=""
                        className="btn btn-danger btn-sm mt-2"
                      >
                        Click here
                      </Link>
                    </div>
                  </div>
                  
                </div>

                <div className="col-lg-3 mt-3">
                  <div className="card border border-0 rounded-3 bgimage4 text-dark text-center">
                    <div className="card-header border-0">
                      <h5 className="text-center mt-4"><b>Today Binary Matching</b></h5>

                      <Link
                        to=""
                        className="btn btn-danger btn-sm mt-2"
                      >
                        Click here
                      </Link>
                    </div>
                  </div>
                  
                </div> */}

                {/* <div className="col-lg-3 mt-3">
                  <div className="card border border-0 rounded-3 bgimage4 text-dark text-center">
                    <div className="card-header border-0">
                    
                      <h5 className="text-center mt-4"><b>Activation Products</b></h5>
                     
                      <Link
                        to="/activationproducts"
                        className="btn btn-danger btn-sm mt-2"
                      >
                        Click here
                      </Link>
                     
                    </div>
                    <p className="display-6 text-dark mt-2">{count}</p>
                  </div>
                </div> */}
              </div>

              {/* =====================row6 ================================= */}

              {/* =====================row7 ================================= */}

              <div className="row mt-4 mb-4">
                <div className="col-lg-6 mt-3">
                  <div className="card border-0 shadow ">
                    <div className="card-header bg bg-info border-0">
                      <h4>Change Sponsor ID</h4>
                    </div>

                    <div className="card-body">
                      <div className="col-lg-12">
                        <label for="exampleInputPassword1" class="form-label">
                          Sponsor ID
                        </label>
                        <input
                          type="password"
                          class="form-control"
                          placeholder="Sponsor ID"
                          id="exampleInputPassword1"
                        />
                      </div>

                      <div className="col-lg-12 mt-3">
                        <button className="btn btn-primary">Submit</button>
                      </div>
                    </div>
                  </div>
                </div>

                {/* <div className="col-lg-6 mt-3">
                  <div className="card border-0 shadow ">
                    <div className="card-header bg bg-info border-0">
                      <h4>Free Activation</h4>
                    </div>

                    <div className="card-body">
                      <div className="col-lg-12">
                        <label for="exampleInputPassword1" class="form-label">
                          User ID
                        </label>
                        <input
                          type="password"
                          class="form-control"
                          placeholder="Enter User ID"
                          id="exampleInputPassword1"
                        />
                      </div>

                      <div className="col-lg-12 mt-3">
                        <label for="exampleInputPassword1" class="form-label">
                          Password
                        </label>
                        <input
                          type="password"
                          class="form-control"
                          placeholder="Enter Password"
                          id="exampleInputPassword1"
                        />
                      </div>

                      <div className="col-lg-12 mt-3">
                        <button className="btn btn-primary">Submit</button>
                      </div>
                    </div>
                  </div>
                </div> */}
              </div>

              {/* ===============================table start========================== */}

              <div className="row">
                <div className="col-lg-6 mt-3">
                  <div className="card border-0 shadow ">
                    <div className="card-header bg bg-info border-0">
                      <h4>Daily Transaction</h4>
                    </div>

                    <div className="card-body">
                      <div className="col-lg-12">
                        <div class="table-responsive">
                          <table class="table table-bordered  mb-0 text-nowrap">
                            <thead>
                              <tr>
                                <th> Sl.No </th>
                                <th> Payment Date </th>
                                <th> Transaction Amount </th>
                                <th> Debit </th>
                                <th> Credit </th>
                                <th> Payment Method </th>
                              </tr>
                            </thead>

                            <tbody>
                              <tr>
                                <td> 1 </td>
                                <td> 24-9-2021 </td>
                                <td> INR 500 </td>
                                <td> INR 300 </td>
                                <td> INR 200 </td>
                                <td> Cash </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-lg-6 mt-3">
                  <div className="card border-0 shadow ">
                    <div className="card-header bg bg-info border-0">
                      <h4>Orders Details</h4>
                    </div>

                    <div className="card-body">
                      <div className="col-lg-12">
                        <div class="table-responsive">
                          <table class="table table-bordered  mb-0 text-nowrap">
                            <thead>
                              <tr>
                                <th> Image </th>
                                <th>Customer</th>
                                <th>Order ID</th>
                                <th>Order Date</th>
                                <th>Order Status</th>
                              </tr>
                            </thead>

                            <tbody>
                              <tr>
                                <td>
                                  <img
                                    src={img}
                                    class="rounded-circle w-32 img-fluid"
                                    style={{ maxWidth: "50px", maxHeight: "50px" }}
                                    alt=""
                                  />
                                </td>
                                <td>Emily Poole</td>
                                <td>PRO12345</td>
                                <td>Online Payment</td>
                                <td className={'Delivered' ? 'text-success' : 'text-danger'}>Delivered</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-lg-12 mt-3 mb-3">
                  <div className="card border-0 shadow ">
                    <div className="card-header bg bg-info border-0">
                      <h4>Product Details</h4>
                    </div>

                    <div className="card-body">
                      <div className="col-lg-12">
                        <div class="table-responsive">
                          <table class="table table-bordered  mb-0 text-nowrap">
                            <thead>
                              <tr>
                                <th> Sl.No </th>
                                <th>ID</th>
                                <th>Category Name</th>
                                <th>Product Name</th>
                                <th>Price 1</th>
                                <th>Price 2</th>
                                <th>Discount</th>
                                <th>Product Description</th>
                                <th>Quantity</th>
                                <th>Image 1</th>
                                <th>Image 2</th>
                                <th>Image 3</th>
                                <th>Image 4</th>
                                <th>Status</th>
                              </tr>
                            </thead>

                            <tbody>
                              {
                                depositApi.map((product, index) => (
                                  <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>{product.id}</td>
                                    <td>{product.cetogery_name}</td>
                                    <td>{product.product_name}</td>
                                    <td>{product.price1}</td>
                                    <td>{product.price2}</td>
                                    <td>{product.discount}</td>
                                    <td>{product.product_discription}</td>
                                    <td>{product.quantity}</td>
                                    <td><img src={`${baseUrl}/${product.image1}`} onClick={() => openImageModal(`${baseUrl}/${product.image1}`)} className="img-fluid" /></td>
                                    <td><img src={`${baseUrl}/${product.image2}`} onClick={() => openImageModal(`${baseUrl}/${product.image2}`)} className="img-fluid" /></td>
                                    <td><img src={`${baseUrl}/${product.image3}`} onClick={() => openImageModal(`${baseUrl}/${product.image3}`)} className="img-fluid" /></td>
                                    <td><img src={`${baseUrl}/${product.image4}`} onClick={() => openImageModal(`${baseUrl}/${product.image4}`)} className="img-fluid" /></td>
                                    <td><button className={product.status === 'Available' ? 'btn btn-success' : product.status === 'Not Available' ? 'btn btn-danger' : ''}>{product.status}</button></td>
                                    {/* <td>{promotion.updatedAt}</td> */}
                                    {/* <td> */}
                                    {/* <button
                                  onClick={function () {
                                    editPromotion(index);
                                    handleShow();
                                  }.bind(this)}
                                >
                                  Edit
                                </button>
                                        <button onClick={delpromotion.bind(this,promotion.id,promotion.type)}> Delete </button>
                                    </td> */}
                                  </tr>
                                ))
                              }
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                        <ReactPaginate
                      previousLabel={"Previous"}
                      nextLabel={"Next"}
                      breakLabel={"..."}
                      pageCount={pageCount}
                      marginPagesDisplayed={2}
                      pageRangeDisplayed={3}
                      onPageChange={handlePageClick}
                      containerClassName={"pagination  justify-content-center"}
                      pageClassName={"page-item "}
                      pageLinkClassName={"page-link"}
                      previousClassName={"page-item"}
                      previousLinkClassName={"page-link"}
                      nextClassName={"page-item"}
                      nextLinkClassName={"page-link"}
                      breakClassName={"page-item"}
                      breakLinkClassName={"page-link"}
                      activeClassName={"active primary"}
                    />
                  </div>
                </div>
              </div>

              {/* ===============================table end========================== */}
            </div>
          </div>
        </div>
      </div>
      {showImageModal && (
        <ImageModal
          isOpen={showImageModal}
          onRequestClose={closeImageModal}
          imageUrl={enlargedImageUrl}
        />
      )}
    </section>
  );
};

export default AdminDashboard;
